var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoundWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "#0067FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M23,11a1,1,0,0,1-1,1H19.659l-2.74,6.394a1.015,1.015,0,0,1-.982.6,1,1,0,0,1-.9-.724L12.064,7.865,8.97,20.242A1,1,0,0,1,8.057,21L8,21a1,1,0,0,1-.937-.648L4.307,13H2a1,1,0,0,1,0-2H5a1,1,0,0,1,.937.648l1.872,4.994L11.03,3.758a1,1,0,0,1,1.931-.032l3.228,11.3,1.892-4.415A1,1,0,0,1,19,10h3A1,1,0,0,1,23,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundWave);
export default __webpack_public_path__ + "static/media/icon-sound-wave.62c82eea9c9e7329167c26d6265287b6.svg";
export { ForwardRef as ReactComponent };